import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import axios from "../axios";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const AttendanceDashboard = () => {
  const navigate = useNavigate();

  const { data: classes, isLoading } = useQuery("myClasses", () =>
    axios.get("/attendance/my-classes").then((res) => res.data)
  );

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Typography variant="h5" component="h2" mb={3}>
        Mark Attendance
      </Typography>

      {(!classes || classes.length === 0) && (
        <Typography color="textSecondary">
          No classes assigned to you. Please contact an administrator.
        </Typography>
      )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: 2,
        }}
      >
        {classes &&
          classes.map((cls) => (
            <Card key={cls.id} elevation={2}>
              <CardActionArea
                onClick={() => navigate(`/attendance/${cls.id}`)}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {cls.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {cls._count.students} student
                    {cls._count.students !== 1 ? "s" : ""}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
      </Box>
    </div>
  );
};

export default AttendanceDashboard;
